import { createSlice } from "@reduxjs/toolkit"
import { getCurrentTimeUnixFormat } from "../../utils/formatDate.js"

export const driverPageSlice = createSlice({
  name: "main",
  initialState: {
    testLatitude: null,
    testLongitude: null,
    startDayTime: null,
    currentLanguage: "He",
    isManagerMode: false,
    showDriversOnRoute: false,
  },
  reducers: {
    setTestLat: (state, action) => {
      state.testLatitude = action.payload
    },
    setTestLong: (state, action) => {
      state.testLongitude = action.payload
    },
    setStartDayTime: (state, action) => {
      state.startDayTime = getCurrentTimeUnixFormat()
    },
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload
    },
    setIsManagerMode: (state, action) => {
      state.isManagerMode = action.payload
    },
    setShowDriversOnRoute: (state, action) => {
      state.showDriversOnRoute = action.payload
    },
  },
})

export const {
  setTestLat,
  setTestLong,
  setStartDayTime,
  setLanguage,
  setIsManagerMode,
  setShowDriversOnRoute,
} = driverPageSlice.actions

export default driverPageSlice.reducer
